import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { CUSTOMER_FORM_INTERCEPTORS } from './common/interceptors';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonConfigModule } from '@xilo-mono/common/config';
import { AgencyLocatorComponent } from './pages/agency-locator/agency-locator.component';
import { XiloButtonModule } from '@xilo/library';
import { CommonUiModule } from '@xilo-mono/common/ui';
import { FormsModule } from '@angular/forms';
import { XiloServicesModule } from '@xilo-mono/xilo-services';
import { RollbarService, LoggingService, rollbarFactory } from './modules/forms/services/log.service';
import * as Sentry from '@sentry/angular';

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(private rollbarLoggingService: LoggingService) {}

  handleError(err: any): void {
    if (environment.production && !window.location.hostname.includes('xilo-dev')) {
      this.rollbarLoggingService.error(err.originalError || err);
    }
  }
}

const DEBUG_MODULES = environment.production ? [] : [StoreDevtoolsModule.instrument()];

@NgModule({
  declarations: [AppComponent, AgencyLocatorComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonUiModule,
    FormsModule,
    XiloButtonModule,
    HttpClientModule,
    FontAwesomeModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot(),
    CommonConfigModule.forRoot(environment),
    ...DEBUG_MODULES,
    XiloServicesModule
  ],
  providers: [
    CUSTOMER_FORM_INTERCEPTORS,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
